<template>
    <rkm-layout-body title="Lista de exame">
        <template v-slot:actions>
            <rkm-button
                @click="openCadastroExameConectaSus"
                authorize="store-parametrizacao-exame"
                color="primary"
            >
                Cadastrar exame (ConectaSUS)
            </rkm-button>

            <rkm-button
                @click="$router.push({name: 'web-service-laboratorio-cliente-exame-create'})"
                authorize="store-web-service-laboratorio-cliente-exame"
                color="primary"
            >
                Cadastrar exame
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/web-service/laboratorio/cliente/exame/List'

export default {
    components: {List},
    methods: {
        openCadastroExameConectaSus() {
            window.open(this.$router.resolve({name: 'parametrizacao-exame-create'}).href, '_blank')
        },
    },
}
</script>